<template>
  <div class="uni-popup-message">
    <div class="uni-popup-message__box fixforpc-width" :class="'uni-popup__' + type">
      <slot>
        <span class="uni-popup-message-text" :class="'uni-popup__' + type + '-text'">{{
          message
        }}</span>
      </slot>
    </div>
  </div>
</template>

<script>
import popup from '../uni-popup/popup.js'
/**
 * PopUp 弹出层-消息提示
 * @description 弹出层-消息提示
 * @tutorial https://ext.dcloud.net.cn/plugin?id=329
 * @property {String} type = [success|warning|info|error] 主题样式
 *  @value success 成功
 * 	@value warning 提示
 * 	@value info 消息
 * 	@value error 错误
 * @property {String} message 消息提示文字
 * @property {String} duration 显示时间，设置为 0 则不会自动关闭
 */

export default {
  name: 'uniPopupMessage',
  mixins: [popup],
  props: {
    /**
     * 主题 success/warning/info/error	  默认 success
     */
    type: {
      type: String,
      default: 'success'
    },
    /**
     * 消息文字
     */
    message: {
      type: String,
      default: ''
    },
    /**
     * 显示时间，设置为 0 则不会自动关闭
     */
    duration: {
      type: Number,
      default: 3000
    },
    maskShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  created() {
    this.popup.maskShow = this.maskShow
    this.popup.messageChild = this
  },
  methods: {
    timerClose() {
      if (this.duration === 0) return
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.popup.close()
      }, this.duration)
    }
  }
}
</script>
<style lang="scss">
.uni-popup-message {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.uni-popup-message__box {
  background-color: #e1f3d8;
  padding: 0.213333rem 0.32rem;
  border-color: #eee;
  border-style: solid;
  border-width: 0.021333rem;
  flex: 1;
}

@media screen and (min-width: 10.666667rem) {
  .fixforpc-width {
    margin-top: 0.426667rem;
    border-radius: 0.085333rem;
    flex: none;
    min-width: 8.106667rem;
    max-width: 50%;
  }
}

.uni-popup-message-text {
  font-size: 0.298667rem;
  padding: 0;
}

.uni-popup__success {
  background-color: #e1f3d8;
}

.uni-popup__success-text {
  color: #67c23a;
}

.uni-popup__warn {
  background-color: #faecd8;
}

.uni-popup__warn-text {
  color: #e6a23c;
}

.uni-popup__error {
  background-color: #fde2e2;
}

.uni-popup__error-text {
  color: #f56c6c;
}

.uni-popup__info {
  background-color: #f2f6fc;
}

.uni-popup__info-text {
  color: #909399;
}
</style>
